import { GrantedPermission } from "@common/components/DetailsPane/icons";
import { vars } from "@common/styles";
import { MoreIcon, PlusIcon } from "@main/pages/shared/icons/icons";
import { rgba } from "polished";
import styled, { css } from "styled-components";

export const AppListDropdown = styled.div`
  user-select: none;

  .dropdown-menu {
    top: 4.7rem;
    z-index: ${vars.zIndex.modalContent};

    width: 40rem;
    padding: 1rem 0;
  }
`;

export const dropdownScroll = `max-height: calc(100vh - 10rem);`;

export const More = styled(MoreIcon)`
  margin-left: 1rem;
  color: ${vars.colors.grey50};
`;

export const Plus = styled(PlusIcon)`
  color: ${vars.colors.grey50};
  margin: 0 auto;
`;

export const Overlay = styled.div<{ $active?: boolean }>`
  background-color: ${rgba("#000", 0)};
  position: fixed;
  margin: auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transition: ${vars.transitions.hover};
  opacity: 0;
  pointer-events: none;
  z-index: -1;

  /* active */
  ${(props) =>
    props.$active &&
    css`
      opacity: 1;
      pointer-events: auto;
      cursor: default;
      z-index: ${vars.zIndex.modalOverlay};
    `}
`;

export const Name = styled.span<{ $wide?: boolean }>`
  max-width: 16rem;
  margin-right: 0.4rem;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const NotificationIndicator = styled.div`
  margin-left: 1rem;
  margin-right: 0.4rem;
  width: 2.2rem;
  height: 2.2rem;
  border-radius: 50%;
  background-color: ${vars.colors.red};
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 2rem;
`;

export const PermissionIcon = styled(GrantedPermission)`
  width: 2.4rem;
  height: 2.4rem;
`;

export const AddAppIcon = styled.img`
  width: 2.4rem;
  height: 2.4rem;
`;

export const AppOptionsContainer = styled.div`
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  border: 1px solid ${vars.colors.grey80};
  background-color: ${vars.colors.grey90};
  justify-content: center;
  align-items: center;
  height: 8rem;
  width: 13rem;

  color: ${vars.colors.white};
  font-weight: 700;
  svg {
    path {
      stroke: ${vars.colors.white};
    }
  }

  &:hover {
    border: 1px solid ${vars.colors.grey70};
    background-color: ${vars.colors.grey80};
  }
`;
